<template>
    <div>
        <tab name="2" :activity-name="activityName"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.sn" placeholder="请输入订单号" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.paymentStatus" placeholder="请选择" size="small">
                        <el-option label="不限制付款状态" value=""></el-option>
                        <el-option label="仅看未支付的" :value="1"></el-option>
                        <el-option label="仅看已支付的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input class="input-with-select" v-model="params.searchValue" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户昵称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="下单时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="sn" label="订单号" show-overflow-tooltip min-width="140"></el-table-column>
                <el-table-column prop="paymentStatus" label="付款状态">
                    <template slot-scope="{row} = scope">
                        <span v-if="row.paymentStatus == 2" class="color-sccess">已付款</span>
                        <span v-else>未付款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="url" label="照片">
                    <template slot-scope="{row} = scope">
                        <!-- <el-image v-for="(item,index) in row.url" :key="index" :src="item | coverImage(100,100)" fit="cover" :preview-src-list="row.url"
                            style="width:40px;height:40px;" class="MR10"></el-image> -->
                            <el-image v-if="row.url.length == 1" :src="row.url[0] | coverImage(40,40)" fit="cover" :preview-src-list="[row.url[0]]"></el-image>
                            <el-button v-else-if="row.url.length > 1" type="text" size="mini" @click="previewImg(row.url)">多图</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="演出名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="userName" label="用户昵称" show-overflow-tooltip min-width="90"></el-table-column>
                <el-table-column prop="createTime" label="下单时间" min-width="150"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <el-dialog :visible.sync="photoListView" title="照片" center append-to-body>
            <div class="preview-box">
                <el-image style="width: 100px; height: 100px;margin: 10px;" v-for="(image, index) in photoList" fit="cover" :src="image | coverImage(200,200)" :preview-src-list="photoList.slice(index).concat(photoList.slice(0,index))" :key="index">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Tab from '../components/tab.vue'
const defaultParams = {
    pageNo: 1,
    activityId: "",
    endTime: "",
    startTime: "",
    timeType: 1,
    paymentStatus: "", //支付状态 1：未支付 2：已支付	
    searchType: 1, //查询类型 1：用户ID 2：用户昵称
    searchValue: "",
    sn: "", //订单编号	
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: { Tab },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                timeType: parseInt(this.$route.query.timeType || 1),
                paymentStatus: parseInt(this.$route.query.paymentStatus) || "",
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                sn: this.$route.query.sn || "",
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
            activityName: this.$route.query.activityName || "",
            photoList: [],
            photoListView: false,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                activityId: this.id,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || '',
            }
            this.listLoading = true;
            this.$request({
                url: "/photo/orderList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //预览图片
        previewImg(list){
            this.photoList = list;
            this.photoListView = true;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>